import React from "react";
import MyTitle from "../myTitle";
import Btn from "../btn";
import styleObj from "./style.module.scss";
import Intro2021 from "./2021";

export default function Intro(props) {
  let { actAddress, meta } = props;

  return (
    <>
      {meta?.is2021 ? (
        <Intro2021 {...props} />
      ) : (
        <div className={styleObj["intro-wrap"]}>
          <MyTitle mainTitle="活动介绍" subTitle="INTRODUCE" />
          <div className={styleObj["content"]}>
            <div className={styleObj["left"]}>
              <div className={styleObj["text"]}>
                <div className={styleObj["title"]}>
                  致敬真实—创维电视秋季新品品鉴会
                </div>
                <div className={styleObj["desc"]}>
                  极果邀请各圈层体验师开启看见真实之旅
                </div>
                <div className={styleObj["tips"]}>
                  将杭州、长沙、北京、青岛、成都、上海六城的精彩呈现于SKYWORTH
                  S82创维0.86高色准OLED电视之中
                </div>
              </div>
              <img
                className={styleObj["entrance"]}
                src={require("../../assets/imgs/chongqing/entrance.png")}
                alt=""
              />
              <img
                className={styleObj["pendant-dot"]}
                src={require("../../assets/imgs/pendant-dot.png")}
                alt=""
              />
            </div>
            <div className={styleObj["right"]}>
              <Btn
                className={styleObj["btn"]}
                href={actAddress}
                text="立即参加"
              />
              <p className={styleObj["desc"]}>- 体验0.86高色准OLED电视 -</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
